import { createFileRoute } from '@tanstack/react-router'
import { ScheduledScreen } from '@/features/scheduled/ScheduledScreen'

export const Route = createFileRoute('/scheduled')({
  component: ScheduledScreen,
})
